export default "__VITE_ASSET__lHxFSpGq__"